import usePrivateAxios from "@/common/api/usePrivateAxios"
import { ErrorResponse } from "@/common/types/errorResponse"
import { useMutation } from "@tanstack/react-query"
import { AxiosResponse } from "axios"
import { CardManuallyActiveValidationSchema } from "../schemas/cardManuallyActivate.schema"

interface UseCardManuallyActivate {
  id?: string
  onSuccess?: (response?: AxiosResponse<any, any>) => void
  onError?: (error: ErrorResponse) => void
}

export const useCardManuallyActivate = ({ id, onSuccess, onError }: UseCardManuallyActivate) => {
  const privateAxios = usePrivateAxios()
  return useMutation({
    mutationKey: ['cardManuallyActivate'],
    mutationFn: (form: CardManuallyActiveValidationSchema) => {
      const payload = {
        ...form,
        manually_activated_reason_file_attachment_attributes: form?.manually_activated_reason_file ? { blob_id: form.manually_activated_reason_file.blob_id} : undefined
      }

      return privateAxios.post(`/cards/${id}/manually_activate`, { ...payload })
    },
    onSuccess,
    onError,
  })
}
